(function () {
  if (window.__arInit) return;
  window.__arInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;
  var io = null;

  function observar(el) {
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('ar-visible'); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ar-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    io.observe(el);
  }

  function initReveals(root) {
    root.querySelectorAll('.ar-reveal, .ar-med__dibujo').forEach(function (el) {
      if (el.dataset.arInit) return;
      el.dataset.arInit = '1';
      observar(el);
    });
  }

  // Inclinación que sigue al cursor (héroe y tarjetas magnéticas)
  function initInclinar(root) {
    if (tactil || reduce) return;
    root.querySelectorAll('[data-ar-inclinar]').forEach(function (el) {
      if (el.dataset.arIncl) return;
      el.dataset.arIncl = '1';
      var max = parseFloat(el.dataset.arInclinar) || 6;
      var zona = el.closest('[data-ar-zona]') || el;
      zona.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width;
        var y = (ev.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((x - 0.5) * 2 * max).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * 2 * max).toFixed(2) + 'deg');
        el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      zona.addEventListener('mouseleave', function () {
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  // Frase que se ilumina palabra a palabra con el scroll
  function initFrase(root) {
    root.querySelectorAll('[data-ar-frase]').forEach(function (el) {
      if (el.dataset.arInit) return;
      el.dataset.arInit = '1';
      var claves = (el.dataset.claves || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var texto = el.textContent.trim().replace(/\s+/g, ' ');
      el.textContent = '';
      texto.split(' ').forEach(function (p, i, arr) {
        var s = document.createElement('span');
        s.className = 'ar-palabra';
        var limpia = p.toLowerCase().replace(/[.,;:!¡?¿"«»]/g, '');
        if (claves.indexOf(limpia) !== -1) s.classList.add('ar-clave');
        s.textContent = p;
        el.appendChild(s);
        if (i < arr.length - 1) el.appendChild(document.createTextNode(' '));
      });
      var palabras = el.querySelectorAll('.ar-palabra');
      if (reduce) { palabras.forEach(function (s) { s.classList.add('ar-on'); }); return; }
      var pendiente = false;
      function pintar() {
        pendiente = false;
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var progreso = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        progreso = Math.max(0, Math.min(1, progreso));
        var n = Math.round(progreso * palabras.length);
        palabras.forEach(function (s, i) { s.classList.toggle('ar-on', i < n); });
      }
      window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
      pintar();
    });
  }

  // Galería y variantes de la página de producto
  function initProducto(root) {
    root.querySelectorAll('[data-ar-producto]').forEach(function (sec) {
      if (sec.dataset.arInit) return;
      sec.dataset.arInit = '1';
      var principal = sec.querySelector('.ar-pr__principal img');
      sec.querySelectorAll('.ar-pr__miniaturas button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (principal) principal.src = b.dataset.src;
          sec.querySelectorAll('.ar-pr__miniaturas button').forEach(function (x) { x.classList.remove('ar-activo'); });
          b.classList.add('ar-activo');
        });
      });

      var formato = sec.dataset.arMoneda || '${{amount_no_decimals}}';
      function dinero(cents) {
        var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato.replace(/\{\{\s*[a-z_]+\s*\}\}/, n);
      }
      var json = sec.querySelector('[data-ar-variantes]');
      var input = sec.querySelector('input[name="id"]');
      var boton = sec.querySelector('[data-ar-comprar]');
      var precio = sec.querySelectorAll('[data-ar-precio]');
      var tachado = sec.querySelector('[data-ar-tachado]');
      if (json && input) {
        var variantes = JSON.parse(json.textContent);
        var selects = sec.querySelectorAll('[data-ar-opcion]');
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
            var label = boton.querySelector('span');
            if (!v) { boton.disabled = true; label.textContent = boton.dataset.textoNo; return; }
            input.value = v.id;
            precio.forEach(function (p) { p.textContent = dinero(v.price); });
            if (tachado) tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
            boton.disabled = !v.available;
            label.textContent = v.available ? boton.dataset.texto : boton.dataset.textoAgotado;
            if (v.featured_image && principal) principal.src = v.featured_image.src;
          });
        });
      }

      // Barra fija de compra en móvil
      var barra = sec.querySelector('.ar-pr__barra');
      if (barra && boton) {
        barra.querySelector('button').addEventListener('click', function () { boton.click(); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { barra.classList.toggle('ar-mostrar', !e.isIntersecting && e.boundingClientRect.top < 0); });
          }).observe(boton);
        }
      }
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root);
    initInclinar(root);
    initFrase(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
